import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import type { FormattedAgentActivity } from '../utils'
import { ActivityVerb } from './ActivityVerb'
import { ActivityContext } from './ActivityContext'
import { ActivityStats } from './ActivityStats'

interface AgentActivityContentProps {
  readonly activity: FormattedAgentActivity
}

export const AgentActivityContent: FC<AgentActivityContentProps> = ({ activity }) => (
  <Box sx={agentContentSx}>
    <ActivityVerb activity={activity} />
    <ActivityContext activity={activity} />
    {activity.suffix && <ActivityStats activity={activity} />}
  </Box>
)

const agentContentSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  overflow: 'hidden',
}
